import { gql } from '@apollo/client';

export const putRFXQuestionMutation = gql`
  mutation putRFXQuestion($rfxQuestion: RFXQuestionInput!) {
    putRFXQuestion(rfxQuestion: $rfxQuestion) {
      rfxQuestionId {
        id {
          value
        }
        revision
      }
      rfxQuestionVersion
    }
  }
`;
